import Rect from '../../nesting/rect';
import IdleState from './idle_state';
import SelectKeepState from './select_keep_state';
import State from './state';

export default class MultipleSelectRectState extends State {
  constructor (context, e) {
    super(context);

    const r = context.root.getBoundingClientRect();
    const { clientX, clientY } = e;
    this.start = {
      x: clientX,
      y: clientY
    };
    this.rect = new Rect();
    context.svg.appendChild(this.rect.element);
  }

  updateRect (context, e) {
    const r = context.root.getBoundingClientRect();
    const { clientX, clientY } = e;
    const wp = context.convert(clientX - r.x, clientY - r.y);
    const sp = context.convert(this.start.x - r.x, this.start.y - r.y);
    this.rect.update(sp.x, sp.y, wp.x, wp.y);
  }

  mouseMove (context, e) {
    this.updateRect(context, e);
    return this;
  }

  shift (part, point) {
    return {
      x: point.o.x + part.position.x,
      y: point.o.y + part.position.y
    };
  }

  mouseUp (context, e) {
    this.updateRect(context, e);

    this.dispose();

    const selected = [];
    context.parts.forEach(part => {
      const candidates = part.getAllCandidates();
      candidates.forEach(point => {
        const p = this.shift(part, point);
        if (this.rect.contains(p)) {
          selected.push(point);
        }
      });
    });

    this.dispose();

    if (selected.length > 0) {
      return new SelectKeepState(context, selected);
    }

    return new IdleState(context);
  }

  dispose () {
    this.rect.dispose();
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/fillet/states/multiple_select_rect_state.js